<template>
    <div>
      <nav class="navbar navbar-dark navbar-expand-xl">
        <a href="/" class="ms-5 navbar-brand">
          <span class="brand-text">Developer Badges</span>
        </a>
        <button class="navbar-toggler mx-5"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarcollapseid">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse mx-3"
             id="navbarcollapseid">
          <ul class="navbar-nav ms-auto">
            <li class="nav-item">
              <RouterLink to="/badges"
                          class="mx-1 nav-link"
                          routerLinkActive="active">
                Badges
              </RouterLink>
            </li>
            <li class="nav-item">
              <RouterLink to="/badges/award"
                          class="mx-1 nav-link"
                          routerLinkActive="active">
                Award
              </RouterLink>
            </li>
            <li class="nav-item">
              <RouterLink to="/faq"
                          class="mx-1 nav-link"
                          routerLinkActive="active">
                FAQ
              </RouterLink>
            </li>
            <li class="nav-item"
                v-if="logged_in">
              <button type="button"
                      class="mx-1 nav-link nav-signout"
                      @click="sign_out">
                Sign out
              </button>
            </li>
          </ul>
        </div>
      </nav>
    </div>
</template>
<script>
  import { Hub } from 'aws-amplify/utils'
  import { signOut, fetchAuthSession } from 'aws-amplify/auth'

  export default {
    name: 'NavBar',
    data() {
      return {
        logged_in: false
      }
    },
    methods: {
      sign_out: async function() {
        console.debug('Signing out')
        await signOut()
        this.check_logged_in()
      },
      check_logged_in: function() {
        fetchAuthSession().then(session => {
          if (!session.tokens) {
            console.debug('NavBar determined you are not logged in')
            this.logged_in = false
            return
          }
          console.debug('NavBar determined you are logged in')
          this.logged_in = true
        })
      }
    },
    mounted() {
      this.check_logged_in()

      Hub.listen('auth', ({ payload }) => {
        switch (payload.event) {
          case 'signedIn':
            this.check_logged_in()
        }
      })
    }
  }

</script>
<style scoped>
  nav {
    background-color: #000 !important;
    border-bottom: 1px solid var(--border-default);
    padding: 0 0;
  }

  .navbar-brand {
    color: #fff;
    text-decoration: none;
  }
  .navbar-brand:hover {
    color: #fff;
  }

  .brand-text {
    font-family: "Inter", sans-serif;
    font-weight: 700;
    font-size: 16px;
    letter-spacing: -0.02em;
    color: #fff;
  }

  .nav-link {
    font-family: "Inter", sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: var(--text-secondary) !important;
    padding: 12px 16px !important;
    transition: color 0.15s ease;
    text-transform: none;
    letter-spacing: 0;
    border-bottom: 2px solid transparent;
  }

  .nav-link:hover {
    color: var(--text-primary) !important;
  }

  .router-link-exact-active {
    color: #fff !important;
    border-bottom: 2px solid var(--accent);
  }

  .nav-signout {
    background: none;
    border: none;
    cursor: pointer;
    text-align: left;
    width: 100%;
  }

  .navbar-toggler {
    border-color: var(--border-default) !important;
  }
  .navbar-toggler:focus {
    box-shadow: none;
  }
</style>

